import { useEffect } from 'react';
import { useParam } from './useParam';
import { useNavigate } from 'react-router-dom';

export const usePageParam = (onPageUpdate?: (page: number) => void) => {
  const navigate = useNavigate();
  const {
    value: page,
    setParam: setPage,
    removeParam: removePage,
  } = useParam({
    key: 'page',
  });
  const pageNr = parseInt(page || '1');

  useEffect(() => {
    if (!page) {
      setPage('1');
    }
  }, [page, setPage]);

  useEffect(() => {
    onPageUpdate && onPageUpdate(pageNr);
  }, [onPageUpdate, pageNr]);

  useEffect(() => {
    return () => {
      const searchParams = new URLSearchParams(window.location.search);

      searchParams.delete('page');
    };
  }, [navigate]);

  return {
    page: pageNr,
    setPage,
    removePage,
  };
};
